import PowerOfZero from '@/kyna/view/_public/PowerOfZero';
import BaseTemplate from '../src/layouts/BaseTemplate'

const Power_Of_Zero = () => {
    return ( 
        <BaseTemplate title="Power of Zero" body={<PowerOfZero />} />
     );
}
 
export default Power_Of_Zero;